import React from 'react'
import CatholicHouseholdMemberQuery from "./CatholicHouseholdMemberQuery";


export const CatholicHouseholdMemberQueryMatrimony = ({
                                                          ...props
                                                      }) => <CatholicHouseholdMemberQuery
    sacrament_type={"matrimony"} {...props} />


